import { buildDiagnosisResult } from './builders';
import type { DiagnosisResultContent } from './types';

/** SACZ（S即興・Aアクティブ・C安心安定・Z癒し） */
const saczContent: DiagnosisResultContent = {
  code: 'SACZ',
  name: '究極の脱力系',
  catchphrase: '旅行してるのか寝てるのか不明。ベッドが世界一の観光地',
  rarity: 4,
  style:
    '「とにかく癒されたい、でも気軽に」を体現する脱力派。計画は立てず、安心できる宿やカフェを拠点にゆるく過ごす。動くときも無理はせず、その日の気分で心地よい場所へ。冒険や詰め込みとは無縁で、何もしない贅沢を知っている。肩の力が抜けた自然体で、一緒にいる人まで癒す稀有なタイプ。',
  strengths: [
    { lead: '究極のリラックス力', text: '何もしない時間を楽しめ、旅で本当に回復できる。' },
    { lead: '安心感がある', text: '無理せず安全圏で過ごすため、トラブルとは無縁。' },
    { lead: '場を和ませる', text: '自然体の脱力感が、同行者の緊張までほぐす。' },
  ],
  weaknesses: [
    { lead: '行動量が少ない', text: 'のんびりしすぎて、見どころや体験を逃すことがある。' },
    { lead: '受け身になりがち', text: '提案を待つ姿勢が多く、旅をリードはしにくい。' },
    { lead: '刺激不足になりやすい', text: '癒し一辺倒だと、後から「もう少し動けば」と思うことも。' },
  ],
  aaru: [
    { icon: 'coffee', text: 'カフェと宿で一日が終わる' },
    { icon: 'msg', text: '「まあ、いっか」が口癖' },
    { icon: 'coffee', text: 'チェックアウト直前まで滞在' },
    { icon: 'camera', text: '写真より「ぼーっとする時間」' },
  ],
  manual: {
    good: 'のんびりを尊重する／何もしない時間を共有する',
    ng: '「せっかくだから動こう」と急かす',
    tips: '見どころは1日1つに絞ると心地よく回れる',
  },
  compatibility: {
    good: 'SACE（ゆるアクティブ）／SRCZ（マイペース）',
    conflict: 'PALE（詰め込み食）／SALE（爆速即興）',
    tips: '「自由解散」を前提にすると気楽に過ごせる',
  },
  destinations: {
    domestic: '温泉地全般（湯治スタイル）／沖縄離島（何もしない贅沢）',
    overseas: 'バリ（癒しのリゾート）／チェンマイ（ゆるい滞在向き）',
  },
};

export const saczDiagnosisResult = buildDiagnosisResult(saczContent);
